import { Anchor } from '@/components/ui/anchor';
import { AppRoutes } from '@/enums/app-routes';

export const NewRegistrationContent = (): React.JSX.Element => {
  return (
    <>
      <h2 data-test="mfa-welcome-heading">Welcome to Cinemark Movie Rewards</h2>
      <div className="flex flex-col gap-md">
        <p data-test="mfa-description-welcome">Thanks for joining, Movie Fan! Your account was successfully created.</p>
        <Anchor className="w-full"
          data-test="button-movie-rewards"
          dataLinkCategory="MFA Modal"
          dataLinkName="Explore Movie Rewards"
          href={AppRoutes.MOVIE_REWARDS}
        >
          Explore Movie Rewards
        </Anchor>
      </div>
    </>
  );
};
